export const OBJECT_LIST_NAME: REACT_QUERY_DEPS_NAME = 'objects'
export const SHARED_OBJECT_LIST_NAME: REACT_QUERY_DEPS_NAME = 'sharedObjects'
